import {APP_BASE} from './router';
import './payment-acceptance.css';
import {PAYMENT_METHODS,paymentMethodPath} from '../src/payment-method-catalog';
import {Link} from './router';
import {PaymentMethodMark} from './payment-method-content';
import {Fragment} from 'react';
import {ServiceBrand} from './service-brand';
import {usePublicLocale} from './public-locale';

export function WalletMarks({decorative=false}:{decorative?:boolean}){
  return <span className="payment-wallet-marks" aria-hidden={decorative||undefined}>
    <img src={`${APP_BASE}/assets/payments/apple-pay.svg`} alt="Apple Pay"/>
    <img src={`${APP_BASE}/assets/payments/google-pay.svg`} alt="Google Pay"/>
  </span>;
}

export function PaymentAcceptance(){
  const {t} = usePublicLocale();
  return <div className="payment-acceptance" aria-label={t('Payment products')}>
    {(['payments','crypto'] as const).map(id=><Fragment key={id}>
      {id==='crypto'&&<hr className="footer-divider"/>}
      <section className={`footer-payment-product footer-payment-product--${id}`} aria-labelledby={`footer-${id}-title`}>
      <h2 id={`footer-${id}-title`}><ServiceBrand product={id} linked/></h2>
      <MethodMarks kind={id==='payments'?'fiat':'crypto'}/>
    </section></Fragment>)}
  </div>;
}

function MethodMarks({kind}:{kind:'fiat'|'crypto'}){
  const {t} = usePublicLocale();
  return <ul className={`footer-payment-methods footer-payment-methods--${kind}`} aria-label={t(kind==='fiat'?'Cards and digital wallets':'Crypto assets and networks')}>
    {PAYMENT_METHODS.filter(method=>kind==='fiat'?method.kind!=='crypto':method.kind==='crypto').map(method=><li key={method.id} className={`footer-payment-method--${method.kind}`}><Link href={`${APP_BASE}${paymentMethodPath(method)}`}>
      <span className="footer-payment-art"><PaymentMethodMark method={method}/></span><span className="footer-payment-name">{t(method.name)}</span>
    </Link></li>)}
  </ul>;
}
